import { useState } from "react";
import { faEdit, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import SubCategorieForm from "./SubCategorieForm";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import axiosConfig from "../../../services/Axios";
import EmptyData from "../../../components/ui/EmptyData";
import PopoverMenu from "../../../components/ui/PopoverMenu";
import { useTranslation } from "react-i18next";

function SubCategoriesList({ categorie, setCategorie, getCategorie }) {
  const { t } = useTranslation();
  const [subCategorie, setSubCategorie] = useState();
  const [modalSubCategorieFormIsOpen, setModalSubCategorieFormIsOpen] =
    useState(false);

  const handleDeleteSubCategorie = (subCategorie) => {
    Swal.fire({
      text: t("global.form.delete") + " " + subCategorie.name + " ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("global.btn.confirm_delete"),
      cancelButtonText: t("global.btn.cancel"),
      customClass: {
        actions: "gap-2 h-20",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          axiosConfig
            .delete(process.env.REACT_APP_API_URL + subCategorie["@id"])
            .then((response) => {
              if (response?.status === 204) {
                toast.success(t("categories.sub-categories.deleted"), {
                  theme: "colored",
                  hideProgressBar: true,
                });

                setCategorie({
                  ...categorie,
                  itemSubCategories: categorie.itemSubCategories.filter(
                    (c) => c.id !== subCategorie.id
                  ),
                });
              }
            });
        } catch (e) {
          if (
            e.response?.status !== 200 &&
            e.response?.data["hydra:description"]
          ) {
            toast.error(e.response?.data["hydra:description"]);
          }
        }
      }
    });
  };

  const openModalSubCategorie = async (subCategorie = null) => {
    setModalSubCategorieFormIsOpen(true);
    setSubCategorie(subCategorie);
  };

  return (
    <div className="mt-8 container m-auto grid grid-cols-12">
      <div className="lg:p-8 lg:px-10 text-sm col-span-12 lg:col-span-9 xl:col-span-12 lg:bg-white rounded-lg">
        <div className="settingsTitle flex justify-between items-center">
          <span className="font-bold text-lg">
            {t("categories.sub-categories.list")}
          </span>
          <div className="text-sm font-normal mb-2">
            <div
              className="btn btn-primary btn-small cursor-pointer"
              onClick={() => openModalSubCategorie(null)}
            >
              {t("categories.sub-categories.create")}
            </div>
          </div>
        </div>
        <div className="bg-bioport-blue-light grid grid-cols-12 text-white font-bold px-4 p-3">
          <div className="col-span-11">
            {t("categories.sub-categories.name")}
          </div>
          <div className="col-span-1 text-center"></div>
        </div>
        {categorie?.itemSubCategories &&
          (categorie?.itemSubCategories.length === 0 ? (
            <EmptyData className="mt-3">{t("global.no-result")}</EmptyData>
          ) : (
            categorie.itemSubCategories.map((sub, key) => (
              <div
                className={`grid grid-cols-12 px-4 p-3 hover:bg-gray-50 ${
                  key % 2 === 0 && "bg-gray-100"
                }`}
                key={key}
              >
                <div className="col-span-11">{sub.name}</div>
                <div className="col-span-1 text-center">
                  <PopoverMenu
                    links={[
                      {
                        link: () => openModalSubCategorie(sub),
                        icon: faEdit,
                        label: t("global.edit"),
                        class:
                          "hover:cursor-pointer hover:underline text-bioport-blue mb-2",
                      },
                      {
                        link: () => handleDeleteSubCategorie(sub),
                        icon: faTrashAlt,
                        label: t("global.form.delete"),
                        class:
                          "hover:cursor-pointer hover:underline text-red-600",
                      },
                    ]}
                  />
                </div>
              </div>
            ))
          ))}
      </div>
      <SubCategorieForm
        setModalSubCategorieFormIsOpen={setModalSubCategorieFormIsOpen}
        modalSubCategorieFormIsOpen={modalSubCategorieFormIsOpen}
        categorie={categorie}
        setCategorie={setCategorie}
        subCategorie={subCategorie}
        setSubCategorie={setSubCategorie}
        getCategorie={getCategorie}
      />
    </div>
  );
}

export default SubCategoriesList;
